exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".smooth-wrap-scroll[data-v-0f40bcfd]{pointer-events:auto;position:sticky;top:0;left:0;height:100vh;width:100%;overflow-y:auto}.smooth-scroll[data-v-0f40bcfd]{pointer-events:none;position:relative}.smooth-content-wrap[data-v-0f40bcfd]{height:100vh;width:calc(100% - 18px);overflow-y:auto;top:0;left:0;pointer-events:none;position:sticky;z-index:-1;overflow:hidden!important}.smooth-content-scroll[data-v-0f40bcfd]{pointer-events:none;overflow:hidden}.smooth-content-scroll [data-v-0f40bcfd]{pointer-events:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f40bcfd","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/lib/smooth-scroll.vue
// module id = 4
// module chunks = 0